import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
const ExamsSetupLazy = React.lazy(
	() => import(/* webpackChunkName : 'ExamSetup' */ './components')
);

export default (store) => {
	return {
		path: 'exam-setup/:campusId?',
		element: <AsyncLoading component={<ExamsSetupLazy />} />,
		children: [],
	};
};
